import { s } from '@/theme/tokens';

export const cloneMetricTypography = {
  valueFontSize: '14px',
  valueLineHeight: '18px',
  deltaFontSize: '12px',
  deltaLineHeight: '16px',
  arrowFontSize: '10px',
  valueDeltaGap: s('sm'),
};
